import React from "react";
import "./style.css";
import Card from "react-bootstrap/Card";
import Table from "react-bootstrap/Table";
import MasterControlProperty from "../MasterControlProperty";
import MasterControlAuto from "../MasterControlAuto";
import MasterControlUmbrella from "../MasterControlUmbrella";

function MasterControl({ agentProperties, agentAutos, agentUmbrellas, agentID }) {
  return (
    <div>
      <Card bg="light" style={{}}>
        <Card.Header style={{ textAlign: "center" }}>
          <h2>
            <strong>Raw Master Control</strong>
          </h2>
        </Card.Header>
        <Card.Body
          style={{
            height: "1000px",
            overflow: "auto",
            backgroundImage: "url(https://picsum.photos/800)",
            backgroundSize: "cover"
          }}
        >
          <Table bordered hover size="sm" responsive>
            <thead>
              <tr style={{ backgroundColor: "white" }}>
                <th>Type</th>
                <th>Client Name</th>
                <th>Status</th>
                <th>Premium</th>
                <th>Split</th>
                <th>Est. Comm</th>
                <th>Renewal Date</th>
                <th>Date Updated</th>
                <th>Date Added</th>
                <th>View Client</th>
              </tr>
            </thead>
            <tbody>
              {agentProperties ? (
                <>
                  {agentProperties.map((property) => (
                    <MasterControlProperty
                      key={property._id}
                      property={property}
                      agentID={agentID._id}
                    />
                  ))}
                </>
              ) : null}

              {agentAutos ? (
                <>
                  {agentAutos.map((auto) => (
                    <MasterControlAuto key={auto._id} auto={auto} agentID={agentID._id} />
                  ))}
                </>
              ) : null}

              {agentUmbrellas.map((umbrella) => (
                <MasterControlUmbrella
                  key={umbrella._id}
                  umbrella={umbrella}
                  agentID={agentID._id}
                />
              ))}
              <tr></tr>
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </div>
  );
}

export default MasterControl;
